/**
 * Copyright (c) 2018 Interacso
 * All rights reserved.
 */

interface IArgs {
  content: any;
  defaultText?: string;
  prefix?: string;
  suffix?: string;
}

export const getTextContent = ({
  content,
  defaultText = '',
  prefix = '',
  suffix = '',
}: IArgs) => {
  if (typeof content === 'string') {
    return `${prefix}${content || defaultText}${suffix}`;
  }

  return content;
};
